/* MW Fitness — popup de bienvenida con 10% de descuento.
   Capta el correo, lo registra como cliente de Shopify con marketing
   aceptado y entrega el código BIENVENIDA10.
   Sin apps: usa el formulario nativo de suscripción del tema. */
(function () {
  'use strict';

  var CODIGO   = 'BIENVENIDA10';
  var CLAVE    = 'mwf_popup_v1';   // recuerda si ya se mostró o se suscribió
  var ESPERA   = 6000;             // ms antes de aparecer
  var DIAS_OFF = 30;               // si lo cierra, no vuelve en 30 días

  function leer() {
    try { return JSON.parse(localStorage.getItem(CLAVE) || '{}'); } catch (e) { return {}; }
  }
  function guardar(o) {
    try { localStorage.setItem(CLAVE, JSON.stringify(o)); } catch (e) {}
  }

  // Shopify redirige aquí tras dar de alta el correo.
  function vuelveDelAlta() {
    return /[?&]customer_posted=true/.test(location.search);
  }

  function yaSuscrita() {
    return !!leer().suscrito;
  }

  function debeMostrarse() {
    var e = leer();
    // Al volver del alta hay que abrirlo sí o sí: es cuando se da el código.
    if (vuelveDelAlta()) return true;
    if (e.suscrito) return false;
    if (e.cerrado && (Date.now() - e.cerrado) < DIAS_OFF * 864e5) return false;
    // No molestar dentro del proceso de compra.
    if (/\/(checkout|cart)/.test(location.pathname)) return false;
    return true;
  }

  function construir() {
    var fondo = document.createElement('div');
    fondo.className = 'mwf-pop';
    fondo.setAttribute('role', 'dialog');
    fondo.setAttribute('aria-modal', 'true');
    fondo.setAttribute('aria-label', 'Obtén 10% de descuento');

    var caja = document.createElement('div');
    caja.className = 'mwf-pop__caja';

    var cerrar = document.createElement('button');
    cerrar.type = 'button';
    cerrar.className = 'mwf-pop__x';
    cerrar.setAttribute('aria-label', 'Cerrar');
    cerrar.innerHTML = '&times;';

    var cuerpo = document.createElement('div');
    cuerpo.className = 'mwf-pop__cuerpo';
    cuerpo.innerHTML =
      '<p class="mwf-pop__mini">OBTÉN</p>' +
      '<p class="mwf-pop__grande">10%<span>OFF</span></p>' +
      '<p class="mwf-pop__mini">EN TU PRIMERA COMPRA</p>' +
      '<p class="mwf-pop__texto">Déjanos tu correo y te enviamos tu código.</p>';

    // El formulario NO se crea aquí: se toma el que renderiza
    // `snippets/mwf-popup-form.liquid` con {% form 'customer' %}. La tienda usa
    // la protección anti-bots de Shopify y los formularios creados por JS se
    // rechazan con "Missing CAPTCHA token"; los que vienen del servidor llevan
    // el token puesto. Al enviarse, la página recarga y vuelve con
    // ?customer_posted=true, que es cuando se muestra el código.
    var deposito = document.getElementById('mwf-popup-form');
    var form = deposito ? deposito.querySelector('form') : null;
    if (!form) return;
    deposito.hidden = false;

    var email = form.querySelector('[name="contact[email]"]');
    var enviarNativo = form.querySelector('[type="submit"]');

    var enviar = enviarNativo;

    var aviso = document.createElement('p');
    aviso.className = 'mwf-pop__aviso';

    var legal = document.createElement('p');
    legal.className = 'mwf-pop__legal';
    legal.innerHTML = 'Al suscribirte aceptas recibir nuestras novedades. ' +
      'Puedes darte de baja cuando quieras. ' +
      '<a href="/pages/politica-de-privacidad" target="_blank" rel="noopener">Política de Privacidad</a>';

    caja.appendChild(cerrar);
    caja.appendChild(cuerpo);
    caja.appendChild(form);        // se mueve el formulario de Liquid al popup
    caja.appendChild(aviso);
    caja.appendChild(legal);
    fondo.appendChild(caja);

    function cerrarPop(guardarCierre) {
      fondo.classList.remove('mwf-pop--visible');
      setTimeout(function () { if (fondo.parentNode) fondo.parentNode.removeChild(fondo); }, 250);
      if (guardarCierre) {
        var e = leer(); e.cerrado = Date.now(); guardar(e);
      }
    }

    cerrar.addEventListener('click', function () { cerrarPop(true); });
    fondo.addEventListener('click', function (ev) { if (ev.target === fondo) cerrarPop(true); });
    document.addEventListener('keydown', function esc(ev) {
      if (ev.key === 'Escape' && fondo.parentNode) { cerrarPop(true); document.removeEventListener('keydown', esc); }
    });

    form.addEventListener('submit', function (ev) {
      var valor = (email.value || '').trim();
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(valor)) {
        ev.preventDefault();               // solo aquí se corta el envío
        aviso.textContent = 'Escribe un correo válido.';
        aviso.className = 'mwf-pop__aviso mwf-pop__aviso--err';
        email.focus();
        return;
      }
      // No se llama a preventDefault: el formulario se envía de verdad (con el
      // token de Shopify). La página recarga y vuelve con ?customer_posted=true,
      // y entonces se muestra el código. Se deja anotado antes de irse.
      var e = leer(); e.suscrito = Date.now(); e.correo = valor; guardar(e);
      enviar.disabled = true;
      enviar.textContent = 'ENVIANDO…';
    });

    // Muestra el código: tras volver del alta, o si ya estaba suscrita.
    function mostrarCodigo() {
      cuerpo.innerHTML =
        '<p class="mwf-pop__mini">TU CÓDIGO</p>' +
        '<p class="mwf-pop__codigo">' + CODIGO + '</p>' +
        '<p class="mwf-pop__texto">10% en tu primera compra. Escríbelo en el carrito o en la pantalla de pago.</p>';
      form.style.display = 'none';
      legal.style.display = 'none';
      aviso.textContent = '';

      var usar = document.createElement('button');
      usar.type = 'button';
      usar.className = 'mwf-pop__btn';
      usar.textContent = 'COMPRAR AHORA';
      usar.addEventListener('click', function () {
        window.location.href = '/discount/' + encodeURIComponent(CODIGO) + '?redirect=/collections/all';
      });
      caja.appendChild(usar);
    }

    if (yaSuscrita()) mostrarCodigo();

    return fondo;
  }

  function abrir() {
    if (!debeMostrarse()) return;
    if (document.querySelector('.mwf-pop')) return;
    var pop = construir();
    document.body.appendChild(pop);
    // fuerza el reflow para que la transición se vea
    void pop.offsetWidth;
    pop.classList.add('mwf-pop--visible');
    var campo = pop.querySelector('.mwf-pop__email');
    if (campo) campo.focus();
  }

  // Si viene del alta, el código se entrega enseguida; si no, tras la espera.
  if (vuelveDelAlta()) {
    var reg = leer(); reg.suscrito = reg.suscrito || Date.now(); guardar(reg);
    setTimeout(abrir, 400);
  } else if (debeMostrarse()) {
    setTimeout(abrir, ESPERA);
  }

  // Permite abrirlo a mano desde cualquier enlace con ?popup=1 o data-mwf-popup
  if (/[?&]popup=1/.test(location.search)) setTimeout(abrir, 300);
  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-mwf-popup]') : null;
    if (t) { e.preventDefault(); abrir(); }
  });
})();
